import { render, staticRenderFns } from "./TeacherSelectionListPage.vue?vue&type=template&id=527e31a2&"
import script from "./TeacherSelectionListPage.vue?vue&type=script&lang=ts&"
export * from "./TeacherSelectionListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports